import React, { useState } from 'react';
import axios from 'axios';

import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { chatbotApi } from '../../../common/src';

const initState = {
  category: '',
  title: '',
  content: '',
};
const WidgetQna = (props) => {
  const { history } = props;
  const [inputState, setInputState] = useState(initState);
  let param = props.childProps.payload.param;
  if (param === undefined || param === null) {
    param = '';
  }
  const preText = props.childProps.state.prevMessage;

  const _onChange = (e) => {
    setInputState({
      ...inputState,
      [e.target.name]: e.target.value,
    });
  };
  const _changeCategory = (e) => {
    setInputState({
      ...inputState,
      category: e.target.value,
    });
  };
  const getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  const _write = async () => {
    const { apiUrl, loginId, authId, pkg } = props;
    // const at = localStorage.getItem('at');
    const at = getCookie('at');
    const { category, title, content } = inputState;
    if (loginId === null || loginId === undefined || loginId === '') {
      // alert('로그인후 이용해 주세요.');
      toast.warn('로그인후 이용해 주세요.');
      return;
    }
    if (category === '') {
      toast.warn('분류를 선택해주세요.');
      // alert('분류를 선택해주세요');
      return;
    }
    if (title === '') {
      toast.warn('제목을 입력해주세요.');
      //alert('제목을 입력해주세요.');
      return;
    }
    if (content === '') {
      // alert('내용을 간략하게 입력해주세요.');
      toast.warn('문의할 내용을 간략하게 입력해주세요.');
      return;
    }
    //console.log(category, title, content);
    try {
      const result = await axios.post(
        apiUrl + '/boardWrite_pkg',
        {
          params: {
            userid: loginId,
            authId: authId,
            board_id: 9,
            title: title,
            category: category,
            content: content,
            notice: 0,
            imgName: '',
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      );

      const intReturn = result.data[0].intReturn;
      if (intReturn === 0) {
        props.childProps.actionProvider._qnaSuccess(content);
      }
    } catch (err) {
      //console.log(err);
    }
  };
  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _qna = () => {
    history.push('/customer/3');
  };
  return (
    <>
      <div className="form-container">
        <h1>1:1 문의하기</h1>
        <div>
          <select
            name="category"
            onChange={_changeCategory}
            defaultValue={param}
          >
            <option value="">카테고리 선택</option>
            <option value="1">vod</option>
            <option value="2">멤버십</option>
            <option value="3">환불</option>
            <option value="4">상품</option>
            <option value="5">배송</option>
            <option value="9">자막오류</option>
            <option value="10">저작권 침해 신고</option>
            <option value="13">신작요청</option>
            <option value="12">이벤트</option>
            <option value="11">기타</option>
          </select>
        </div>
        <div>
          <input
            type="text"
            name="title"
            placeholder="제목입력"
            value={inputState.title}
            onChange={_onChange}
          />
        </div>
        <div>
          <textarea
            name="content"
            placeholder="문의 내용입력"
            value={inputState.content}
            onChange={_onChange}
          />
        </div>
        <div onClick={_write} className="btn">
          문의하기
        </div>
        <div onClick={_qna} className="btn-cancel">
          1:1 문의 게시판으로 이동
        </div>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText && (
            <div onClick={_prev} className="prev">
              <img src="/img/chatbot/icon_prev.png" />
              이전 단계로 이동
            </div>
          )}
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default shopContext(withRouter(WidgetQna));
